module.exports = __webpack_public_path__ + "static/media/single-message.ad68089a.jpg";